/*document.querySelectorAll('.Blog_tags_leftside_title_new').forEach((title) => {
    title.addEventListener('click', function () {
        const parent = this.closest('.Blog_tags_leftside_new');
        const content = parent.querySelector('.Blog_tags_leftside_lists_main_new');

        if (parent.classList.contains('open')) {
            // close
            content.style.maxHeight = content.scrollHeight + "px";
            requestAnimationFrame(() => {
                content.style.maxHeight = "0px";
            });
            parent.classList.remove('open');
        } else {
            // open
            content.style.maxHeight = content.scrollHeight + "px";
            parent.classList.add('open');
        }
    });
});*/

document.querySelectorAll('.Blog_tag_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: false,
        grabCursor: false,
        spaceBetween: 10,
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: !0
    })
  }
});

class MainBlog extends HTMLElement {
    constructor() {
        super();

        this.activeYear = 'all';

        this.tagItems = this.querySelectorAll("[js-tag-item]");
        this.mainBlog = this.querySelector("[js-main-blog]");

        this.tagItems.forEach(tag =>
            tag.addEventListener("click", this.renderBlog.bind(this))
        );

        this.init();
    }

    init() {
        // Pagination
        this.paginationItems = this.querySelectorAll("[js-pagination-item]");
        this.paginationItems.forEach(pagination =>
            pagination.addEventListener("click", this.renderBlog.bind(this))
        );

        // Year filter
        this.yearItems = this.querySelectorAll("[data-year]");
        this.yearItems.forEach(year =>
            year.addEventListener("click", this.filterByYear.bind(this))
        );

        // Restore active year button after AJAX reload
        this.yearItems.forEach(btn => {
            btn.classList.toggle(
                "active",
                btn.dataset.year === this.activeYear
            );
        });

        this.applyYearFilter();
    }

    filterByYear(evt) {
        evt.preventDefault();

        const target = evt.currentTarget;

        this.activeYear = target.dataset.year;

        this.yearItems.forEach(btn =>
            btn.classList.remove("active")
        );

        target.classList.add("active");

        this.applyYearFilter();
    }

    applyYearFilter() {
        const articles = this.querySelectorAll(
            ".Blog_inneritem_loop_block_new"
        );

        let visibleCount = 0;

        articles.forEach(article => {
            const articleYear = article.getAttribute("grid-data-year");

            const showArticle =
                this.activeYear === "all" ||
                articleYear === this.activeYear;

            article.style.display = showArticle ? "" : "none";

            if (showArticle) {
                visibleCount++;
            }
        });

        const pagination = this.querySelector(".Blog_inneritem_load_new");

        if (pagination) {
            pagination.classList.toggle(
                "hidden",
                visibleCount !== articles.length
            );
        }
    }

    renderBlog(evt) {
        evt.preventDefault();

        const { currentTarget } = evt;
        const isTag = currentTarget.classList.contains("blog__tag");

        const href = currentTarget.getAttribute("href");

        if (!href) return;

        const url = isTag
            ? `${href}?section_id=${this.mainBlog.getAttribute("data-section-id")}`
            : `${href}&section_id=${this.mainBlog.getAttribute("data-section-id")}`;

        this.updateLoading(true);

        if (isTag) {
            this.updateStatus(currentTarget);
        }

        this.updateScroll();
        this.updateURLHash(href);

        this.renderSectionFromFetch(url);
    }

    updateLoading(isLoading) {
        if (isLoading) {
            this.mainBlog.classList.add("loading");
        } else {
            this.mainBlog.classList.remove("loading");
        }
    }

    updateStatus(target) {
        this.tagItems.forEach(tag =>
            tag.classList.remove("active")
        );

        target.classList.add("active");
    }

    updateScroll() {
        const scrollTo = this.offsetTop;

        window.scrollTo({
            top: scrollTo,
            behavior: "smooth"
        });
    }

    updateURLHash(url) {
        history.pushState({ url }, "", url);
    }

    renderSectionFromFetch(url) {
        fetch(url)
            .then(response => response.text())
            .then(html => {
                const doc = new DOMParser().parseFromString(
                    html,
                    "text/html"
                );

                const newContent = doc.querySelector("[js-main-blog]");

                if (newContent) {
                    this.mainBlog.innerHTML = newContent.innerHTML;
                }

                // Re-bind pagination and year filter events
                this.init();
            })
            .catch(error => {
                console.error("Blog fetch error:", error);
            })
            .finally(() => {
                this.updateLoading(false);
            });
    }
}

customElements.define("main-blog", MainBlog);